import useAuth from '@State/Auth/useAuth';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RRDLink } from 'react-router-dom';
import styled from 'styled-components';
import logotype from '../../assets/logotype/remondis-logo.svg';
import { useLoginUrl } from '../../hooks/useLoginUrl';
import { size } from '../../layout/helpers';
import { Button, ButtonLink } from '../Button';
import { Container } from '../Container';
import { RouterLink } from '../Link';
import { Logo, LogoImg } from './wrapper';

const LogoLink = styled.a`
  display: block;
`;

const Wrapper = styled.div`
  background-color: ${(props) => props.theme.color.bg.alt};
`;

const Inner = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${size(15)};

  ${(props) => props.theme.breakpoint.LtSm} {
    height: ${size(9)};
  }
`;

const ButtonContainer = styled.div`
  display: flex;

  ${(props) => props.theme.breakpoint.LtSm} {
    display: none;
  }
`;

const PublicHeader = () => {
  const { t } = useTranslation();
  const { authenticated } = useAuth();
  const loginUrl = useLoginUrl();

  const logo = <LogoImg src={logotype} alt={t('header_logotype_alt')} />;

  return (
    <Wrapper>
      <Container>
        <Inner>
          <Logo>
            {authenticated ? (
              <RRDLink to="/" title={t('navigation_home_title')}>
                {logo}
              </RRDLink>
            ) : loginUrl ? (
              <LogoLink href={loginUrl} title={t('header_login_button')}>
                {logo}
              </LogoLink>
            ) : (
              <span title={t('header_logotype_alt')}>{logo}</span>
            )}
          </Logo>

          <ButtonContainer>
            <RouterLink to="/register-user">
              <Button $tone="clear-dark">{t('header_register_user_button')}</Button>
            </RouterLink>

            {loginUrl ? (
              <ButtonLink $tone="outline" href={loginUrl}>
                {t('header_login_button')}
              </ButtonLink>
            ) : (
              <Button $tone="outline" disabled>
                {t('header_login_button')}
              </Button>
            )}
          </ButtonContainer>
        </Inner>
      </Container>
    </Wrapper>
  );
};

export default PublicHeader;
